/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class GetGraphCodeService extends BaseService {
  constructor() {
    super(constants.GET_GRAPH_CODE, 'graphCodeStatus');
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { graphId, version } = payload;

    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(`/code/${graphId}?version=${version}`, {
        headers: enhancedHeaders
      });
    }
    return this.getClient('aiadmin').get(`/code/${graphId}?version=${version}`, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    const graphCodeModel = Framework.getStoreRegistry().getStore('graphCodeModel');

    if (data && data.success) {
      graphCodeModel.setGraphCode({
        code: data.code || ''
      });
      Framework.getStoreRegistry().getStore('notificationState').set({
        open: true,
        type: 'success',
        message: 'Graph code fetched successfully!'
      });
    } else {
      graphCodeModel.setError(data?.message || 'Failed to fetch graph code');
    }
  }

  handleError(error) {
    const graphCodeModel = Framework.getStoreRegistry().getStore('graphCodeModel');
    const { response } = error;

    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      graphCodeModel.setError(data?.message || 'Failed to fetch graph code');
      Framework.getStoreRegistry()
        .getStore('notificationState')
        .set({
          open: true,
          type: 'error',
          message: data?.message || 'Failed to fetch graph code'
        });
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const errorMessage = 'Request timeout. Please try again.';
      graphCodeModel.setError(errorMessage);
      Framework.getStoreRegistry().getStore('notificationState').set({
        open: true,
        type: 'error',
        message: errorMessage
      });
    } else {
      graphCodeModel.setError(error.message || 'Failed to fetch graph code');
      Framework.getStoreRegistry()
        .getStore('notificationState')
        .set({
          open: true,
          type: 'error',
          message: error.message || 'Failed to fetch graph code'
        });
    }
  }
}
